import educationData from './data/education_data.js';

export default function Education() {
  return (
    <section className="content" id='Education'>
      <h2>Education</h2>
      
      <div className='project'>
        {educationData.map(education => (
          <div key={education.id}>
            <div className='project-title'>
              <h3>{education.school}</h3>
              <p>{education.date}</p>
            </div>
            <p className='lead'>{education.certificate}</p>
            
            {education.content.split('*').map((item, index) => (
                <p className='education-description' key={index}>{item.trim()}</p> 
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
